<script>
import { Row, Col, Toast } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-member-accept',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            member: {
                organizationName: null,
                role: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        welcomeTitle() {
            if (this.locale.localeProp) {
                return this.locale.localeProp('welcome-title', {role: this.member.role})
            }
            return ''
        },
        welcomeOrganization() {
            if (this.locale.localeProp) {
                return this.locale.localeProp('welcome-organization', {organization: this.member.organizationName})
            }
            return ''
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onDownloadBtnClick() {
            Toast(this.locale['coming-soon'])
        }
    },
}
</script>

<template>
    <div class="member-accept bg-white">
        <div class="head justify-center vertical-center">
            <div class="welcome-message vertical-center">
                <div class="inline-block">
                    <div class="symbol-wrapper">
                        <img src="@/assets/org/accept-symbol.png" style="width: 45px; height: 45px;"/>
                    </div>
                </div>
                <div class="inline-block l-outer-margin">
                    <div class="welcome-title">
                        <span>{{ welcomeTitle }}</span>
                    </div>
                    <div class="welcome-org">
                        <span>{{ welcomeOrganization }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="feature-title text-center">
                <span>{{ locale['download'] }}</span>
                <span class="logo"><img src="@/assets/org/logo-square-icon.svg"/></span>
                <span>{{ locale['download-app-title'] }}</span>
            </div>
            <div class="feature-grid">
                <van-row gutter="10">
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-org.svg"/></span>
                            <span class="label">{{ locale['feature-item-org'] }}</span>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-live.svg"/></span>
                            <span class="label">{{ locale['feature-item-live'] }}</span>
                        </div>
                    </van-col>
                </van-row>
                <van-row gutter="10">
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-fee.svg"/></span>
                            <span class="label">{{ locale['feature-item-fee'] }}</span>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-stats.svg"/></span>
                            <span class="label">{{ locale['feature-item-stats'] }}</span>
                        </div>
                    </van-col>
                </van-row>
                <van-row gutter="10">
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-schedule.svg"/></span>
                            <span class="label">{{ locale['feature-item-schedule'] }}</span>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-insurance.svg"/></span>
                            <span class="label">{{ locale['feature-item-insurance'] }}</span>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="footer wp100 fixed-bottom">
            <div class="download-bar vertical-center">
                <span><img src="@/assets/org/ios-icon.svg"/></span>
                <span><img src="@/assets/org/android-icon.svg"/></span>
                <span class="desc">{{ locale['download-app-label'] }}</span>
                <span>
                    <span class="download-btn text-center" @click="onDownloadBtnClick">
                        <span class="label">{{ locale['download-now'] }}</span>
                    </span>
                </span>
            </div>
        </div>
        <div class="unsafe-area-bottom-mask"/>
    </div>
</template>

<style scoped>
.member-accept {
    height: 100vh;
}
.head {
    height: 192px;
    width: 100%;
    background: linear-gradient(180deg, #DBEBFA 0%, #DBEBFA 100%);
}
.welcome-title span {
    font-family: Source Han Sans;
    font-size: 15px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    color: #3D3D3D;
}
.welcome-org span {
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #999999;
}
.feature-title {
    margin-top: 38px;
}
.feature-title span {
    font-family: Source Han Sans;
    font-size: 15px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    color: #666666;
}
.feature-title .logo {
    padding: 2px;
}
.feature-grid {
    margin: 28px 45px;
}
.feature-grid .item-wrapper {
    border-radius: 5px;
    background: #F1F1F1;
    height: 57px;
    margin-bottom: 6px;
}
.feature-grid .item-wrapper .icon {
    margin-right: 4px;
    padding-top: 6px;
}
.feature-grid .item-wrapper .label {
    font-family: Source Han Sans;
    font-size: 15px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #666666;
}
.download-bar {
    margin-left: 22px;
    margin-bottom: 40px;
    width: 311px;
    height: 47px;
    border-radius: 5px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    padding-left: 20px;
}
.download-bar .desc {
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: 350;
    line-height: normal;
    letter-spacing: 0.25px;
    color: #8A8A8A;
    margin-left: 7px;
    margin-right: 14px;
}
.download-btn {
    width: 100px;
    height: 47px;
    border-radius: 5px;
    background: #EE4B22;
    display: inline-block;
}
.download-btn .label {
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.25px;
    color: #FFFFFF;
    line-height: 47px;
}
</style>